export const property = {
  gamefi: "GameFi",
  mc_official_verify_unofficial: "인증되지 않은 출처",
  mc_official_verify_official: "공식 ",
  mc_official_verify_fotter_tip_1:
    "위험 알림: Biking 명의사기 사칭 가짜 직원의 온라인/전화 사기 방지에 대한 위험",
  mc_official_verify_fotter_tip_2:
    "Biking' 명의사기 사칭·남용 경각심을 위한 엄정한 성명 및 위험제시",
  mc_official_verify_modal_tip_1:
    "검색하신 [{query}]는 Biking 공식 채널 입니다.",
  mc_official_verify_modal_tip_3: "입력한 정보와 형식이 올바른지 확인하세요:",
  mc_official_verify_modal_tip_4: "휴대폰 번호: xx-xxxxxxxxx",
  mc_official_verify_modal_type_email: "이메일",
  mc_official_verify_modal_type_domain: "도메인",
  mc_official_verify_modal_type_channel: "채널",
  mc_official_verify_input_placeholder:
    "인증을 위해 정보와 형식을 올바르게 입력하세요.",
  mc_official_verify_head_title: "Biking 공식 검증 채널 | Biking 거래소",
  mc_official_verify_head_description: "Biking 공식 검증 채널",
  mc_official_verify_title: "공식 채널 검증",
  mc_official_verify_discription_new:
    "이 페이지에서 URL, 이메일 주소, 전화번호 또는 X나 텔레그램과 같은 소셜 미디어 계정이 인증된 Biking 공식 출처인지 확인할 수 있습니다. 이를 통해 피싱 및 온라인 사기로 인한 자산 손실을 방지할 수 있습니다.",
  mc_official_verify_fotter_tip_3:
    "Biking, 기본 사용자 가이드: 신규 사기 스캠을 피하는 방법!",
  mc_unofficial_verify_modal_tip_1:
    "검색하신 [{query}]는 인증된 Biking 공식 출처가 아닙니다.",
  mc_official_verify_discription:
    "Biking 명의로 이루어지는 사기를 방지하기 위해 아래에서 해당 채널이 Biking의 공식 채널인지 여부를 확인하시기 바라며, X, 페이스북, 텔레그램, 전화번호, 위챗 등을 포함하되 이에 국한되지 않습니다.",
  mc_official_head_title1: "Biking 공식 채널, 뉴스 및 간행물 확인",
  mc_official_head_keywords1: "Biking 검증, Biking 뉴스, Biking 공식 계정",
  mc_official_head_description1:
    "Biking 채널의 진위 여부를 확인하세요. 공식 검증 도구를 사용하여 Biking 관련 채널, 뉴스 및 간행물의 적법성을 확인하세요.",
  mc_official_verify_verified_title: "공식 출처 확인",
  mc_official_verify_modal_tip_5:
    "텔레그램/X/페이스북/유튜브: @xxxxx (@ 기호 포함)",
  mc_official_verify_modal_tip_6: "틱톡/인스타그램: xxxx(@ 기호 제외)",
  mc_official_verify_modal_tip_7: "디스코드: xxxx#xxxx(@ 기호 제외)",
  mc_official_verify_modal_tip_8:
    "링크드인/텔레그램 그룹/미디엄/레딧: https://xxxxx(웹사이트 링크)",
  mc_official_verify_modal_tip_9:
    "형식에 대해 궁금한 점이 있으면 언제든지 고객 지원 센터로 문의하세요.",
  mc_official_verify_modal_tip_10:
    "*계정 정보 및 비밀번호를 다른 사람에게 공개하지 마세요.",
  mc_official_verify_modal_tip_11: "*사기에 주의하고 신중하게 이용하세요.",

  tag: "댓글을 입력하세요",
  qbcbcg: "성공적인 입금을 보장하기 위해 TON 주소와 댓글을 함께 복사하십시오.",
  qsrzqje: "올바른 금액을 입력하세요",
  games: "게임 계정",
  cbxz: "Ethereum(ERC20) 입금 안내",
  tbxz: "Ethereum(ERC20) 출금 안내",
  ctbzysx:
    "주의: 모든 FUFU 공식 스마트 계약 전송 시 2%의 추가 수수료가 부과됩니다.",
  dzcw: "잘못된 주소",
  czqkqrs: "입금 블록 확인 수",
  mc: "이름",
  cjsj: "생성 시간",
  lx: "유형",
  sl: "수량",
  cwjl: "재무 기록",
  ylzh: "수익",
  ddtx: "출금 대기",
  txcg: "출금 완료",
  yhcx: "사용자 취소",
  qbcbjl: "전체 입금 기록",
  zczl: "자산 개요",
  zjzh: "자금 계정",
  mbzh: "매수 계정",
  xhzh: "현금 계정",
  hyzh: "계약 계정",
  lczh: "재무 계정",
  gdzh: "거래 계정",
  giftzh: "기프트 계정",
  bwzh: "비킹 카드",
  mozh: "모의 계정",
  mnhy: "모의 계약",
  sxffy: "시스템 리베이트",
  kt: "에어드랍",
  xtkc: "시스템 차감",
  zcfb: "자산 분포",
  zcdt: "자산 동향",
  zh: "계정",
  zc: "자산",
  czjl: "입금 기록",
  txls: "출금 기록",
  hzjl: "이체 기록",
  mmjl: "매매 기록",
  cb: "입금",
  tx: "출금",
  hz: "이체",
  mb: "매수",
  jy: "거래",
  zwsj: "데이터 없음",
  ckqb: "모두 보기",
  bz: "통화",
  qc: "전체",
  zhze: "총 잔액",
  syzc: "남은 자산",
  djzc: "동결 자산",
  cz: "조작",
  sl: "수량",
  cbdz: "입금 주소",
  sj: "시간",
  zt: "상태",
  ms: "설명",
  hzfx: "이체 방향",
  hzse: "이체 금액",
  txdz: "출금 주소",
  sxf: "수수료",
  ddh: "주문 번호",
  zj: "총 가격",
  dj: "단가",
  jysl: "거래 수량",
  jydx: "거래 상대",
  zhqy: "계정 권익",
  zhqytips: "계정 권익 = 사용 가능 보증금 + 포지션 보증금",
  kybzj: "사용 가능 보증금",
  kybzjtips: "개좌 개설 및 이체에 사용되는 보증금",
  cwbzj: "포지션 보증금",
  cwbzjtips: "현재 보유 포지션을 유지하기 위해 사용되는 보증금",
  srbz: "해당 통화를 입력하십시오",
  ycxzc: "작은 자산 숨기기",
  sy: "모든",
  qb: "모두",
  qx: "모두",
  zhi: "부터",
  ksrq: "시작일",
  jsrq: "종료일",
  cx: "조회",
  dc: "내보내기",
  zjqt: "최근 7 일",
  zjygy: "지난 한 달",
  qbsj: "전체 시간",
  usdt: "USDT",
  ddlx: "주문 유형",
  gm: "구매",
  cs: "판매",
  czxq: "입금 상세 정보",
  usdtcbjl: "{coinName} 입금 기록",
  cbsl: "입금 수량",
  cbzt: "입금 상태",
  crdbz: "입금할 통화를 선택하십시오",
  tqdbz: "인출할 통화를 선택하십시오",
  rmbz: "인기있는 화폐",
  qxz: "선택하세요",
  cbwl: "입금 네트워크",
  cbtips:
    "인출 플랫폼이 선택한 네트워크와 일치하는지 확인하십시오. 그렇지 않으면 자산이 손실될 수 있습니다.",
  txfs: "출금 방법",
  lstx: "블록체인 출금",
  xyb: "다음 단계",
  yxzdq: "현재 선택됨",
  dbz: "의 통화",
  cxxz: "다시 선택",
  dzkbz: "주소 라이브러리 주소 부족, 관리자에게 문의하십시오",
  qxzcrdbz: "입금할 통화를 먼저 선택하십시오",
  qxzcbwl: "입금 네트워크를 선택하십시오",
  qxztqdbz: "통화를 먼저 선택하십시오",
  cr: "입금",
  tq: "출금",
  cbxq: "입금 상세 정보",
  txxq: "출금 상세 정보",
  usdttxjl: "{coinName} 출금 기록",
  qbtxjl: "모든 출금 기록",
  zyxx: "중요: 이 주소로는 {coinName}만 전송할 수 있습니다. 다른 암호화폐를 보내면 자금을 손실할 수 있습니다.",
  jzjcr: "자금 보충",
    smewm: "QR 코드를 스캔하거나 다음 정보를 전송 플랫폼으로 복사하세요",
    xcdzcz: "이 주소에 비통화 입금 시 귀하의 자산을 회수할 수 없게 됩니다",
    xcdzczss: "XRP를 입금할 때 반드시 태그를 복사해야 하며, 그렇지 않으면 자금 손실이 발생할 수 있습니다.",
    znhycz: "현재 스마트 계약 충전, 패키지 충전, 블록 보상 충전은 지원되지 않습니다",
    usdtcbdz: "{coinName} 입금 주소",
    fzdz: "주소 복사",
    usdtdz: "{coinName} 주소",
    zxcbe: "최소 입금 금액",
    zytx2:
    "중요: 수신 플랫폼이 귀하가 선택한 {coinName} 네트워크를 지원하는지 확인하십시오. 그렇지 않으면 자금을 잃게 됩니다.",
    kytxwl: "{coinName} 사용 가능한 출금 네트워크",
    xzwl: "네트워크 선택",
    dzym: "{coinName} 주소",
    srdz: "주소를 입력하거나 주소록에서 선택하세요",
    jymm: "거래 비밀번호",
    qsrjymm: "거래 비밀번호를 입력하세요",
    zxtbe: "최소 출금 금액: {minAmount}",
    ky: "사용 가능:",
    zhztbxe: "계정의 총 출금 한도",
    gjxyddj:
    "귀하의 검증 수준에 따라 24시간 이내에 제한된 금액만 출금할 수 있습니다. 한도는 USD를 귀하가 선택한 디지털 통화로 변환하여 계산됩니다.",
  scbdjd:
    "암호화폐 가격의 변동이 크기 때문에 해당 암호화폐의 수수료는 플로팅 수수료이며, 지난 24시간 평균 가격에 따라 0.2-0.2 USDT의 수수료가 부과되어 속도를 높일 수 있습니다.",
  yqdz: "예상 입금",
  yqdzwf: "예상 입금은 음수일 수 없습니다.",
  sfrz: "본인 인증",
  ggyzm: "Google 인증 코드",
  dxyzm: "SMS 인증 코드",
  yxyzm: "이메일 인증 코드",
  qsryzm: "인증 코드를 입력하세요",
  fsyzm: "보내다",
  cxfs: "재전송",
  tj: "제출",
  qxztxwl: "출금 네트워크를 선택하십시오",
  qsrdz: "주소를 입력하십시오",
  qxzdz: "주소를 선택하십시오",
  qxzyzfs: "인증 방식을 선택하십시오",
  qsrtqsl: "인출 수량을 입력하십시오",
  qwcyz: "인증을 완료하십시오",
  qqrbdsj: "휴대전화가 바인딩되었는지 확인하세요",
  qqrbdyx: "이메일이 바인딩되었는지 확인하세요",
  fzcg: "복사 성공!",
  tbcg: "출금 성공",
  usdttxdz: "{coinName} 출금 주소",
  lmc: "체인 이름:",
  qtj: "*추가해 주세요",
  dz: "주소",
  fei: "비",
  zjds: "주소가 자산 손실을 초래할 수 있습니다",
  yzfs: "인증 방식",
  yzm: "인증 코드",
  remark: "비고",
  qsrremark: "비고를 입력하세요",
  tjdzcg: "주소 추가 성공",
  qxxzyzfs: "먼저 인증 방식을 선택하십시오",
  qsrtxdz: "출금 주소를 입력하십시오",
  stop: "중지",
  qr0: "0 확인",
  qr1: "1 확인",
  dqr: "확인 대기 중",
  czcg: "입금 완료",
  hzz: "이체 중",
  ywc: "완료",
  sb: "실패",
  zzcl: "처리 중",
  ddsh: "심사 대기 중",
  txcg: "출금 완료",
  cxcg: "취소 완료",
  ddtx: "출금 대기 중",
  txsb: "출금 실패",
  slsb: "체인 실패",
  dfk: "지불 대기 중",
  yfk: "지불 완료",
  yqx: "취소됨",
  ssz: "송장 대기 중",
  gdfrhz: "팔로우 보너스 이체",
  hyzh_to_gdzh: "계약 계정 - 팔로우 계정",
  gdzh_to_hyzh: "팔로우 계정 - 계약 계정",
  ddcl: "처리 대기 중",
  cg: "성공",
  zchz: "자산 이체",
  ljhz: "즉시 이체",
  cong: "부터",
  dao: "까지",
  qtzh: "다른 계정",
  qxzbz: "통화를 선택하세요",
  qsrsl: "수량을 입력하세요",
  khz: "이체 가능:",
  ye: "잔액:",
  hzcg: "이체 성공",
  zcgl: "자산 개요",
  xrzx: "신규 고객 전용",
  zzc: "총 자산",
  jryk: "오늘 수익/손실",
  zgjz: "최대 3200 USDT의 새 고객 선물세트를 받아보세요!",
  zhrj: "계정에 입금하세요",
  xzrjfs:
    "입금 후 암호화폐를 구매할 수 있습니다. 실제 상황에 따라 입금 방법을 선택할 수 있습니다.",
  czszhb: "암호화폐 입금",
  yyydszhb: "다른 플랫폼에서 이미 보유한 암호화폐를 비킹 계정으로 입금합니다.",
  czfb: "법정화폐 입금",
  czzhz:
    "보유하고 있는 법정화폐를 비킹 계정에 입금하여 은행 카드, 이체 등 다양한 결제 방법을 지원합니다.",
  maibi: "매입",
  tgdsfmb: "은행 카드, P2P, 제3자 등 다양한 방법으로 암호화폐를 구매합니다.",
  yqyl: "초대 보상",
  yqfy: "친구 초대시 20% 보상을 받으세요",
  cxzzn: "초보자 가이드",
  czzh: "비킹 계정 만들기",
  hdxrj: "100 USDT의 신규 고객 보너스를 받으세요",
  ck: "입금",
  tzndzh:
    "귀하의 계정에 투자하여 여행을 시작하세요. 다양한 결제 방법을 지원합니다.",
  wcsfrz: "본인 인증(KYC) 완료",
  hgzh: "본인 인증(KYC)을 완료하고 규정 준수 계정이 되세요.",
  ksjy: "거래 시작",
  tsgd: "판매, 구매 또는 거래 복사를 시작하여 더 많은 것을 탐색하세요.",
  ksndlc: "여행을 시작하세요",
  kjydjmhb: "거래 가능한 암호화폐",
  jmhb: "암호화폐의 총 가치는 12284.85 억 미국 달러입니다.",

    
  批量导入地址:'일괄적으로 주소 가져오기',
  请输入地址或名称:'주소나 이름을 입력해주세요',
  地址名称:'주소 명',
  上传普通地址:'일반 주소 업로드',
  上传成功:'업로드 성공',
  一次只能上传一个文件哦:'한 번에 하나의 파일만 업로드할 수 있습니다.',
  文件大小不得超过10M:'파일 크기는 10M를 초과할 수 없습니다.',
  请先选择要上传的文件:'먼저 업로드할 파일을 선택하세요.',
  只能上传后缀是:'접미사가 .xlsx, .xls 또는 .csv인 파일만 업로드할 수 있습니다.',
  将文件拖到此处:'여기로 파일을 드래그하거나',
  点击上传:'업로드하려면 클릭하세요.',
  最大1MB:'CSV, XLS, XLSX 파일 최대 1MB',
  编号:'일련번호',
  所属网络:'네트워크에 속함',
  地址簿:'주소록',
  新增地址:'주소 추가',
  提币地址一次不超过100个:'한 번에 출금 주소 수는 100개를 초과할 수 없습니다.',
  添加地址:'주소 추가',
  保存地址:'언제 저장',
  下载模板:'템플릿 다운로드',
  批量提现:'일괄 출금',
  请输入Memo:'메모를 입력해주세요',
  请输入地址名称:'주소 이름을 입력하세요',
  输入正确地址可添加地址成功:'주소를 성공적으로 추가하려면 올바른 주소를 입력하세요.',
  您可以通过:'CSV, XLS 또는 XLSX 형식 파일(최대 1MB)을 통해 최대 20개의 공통 주소를 업로드할 수 있습니다. 각 열의 제목은 템플릿과 일치해야 합니다. 그렇지 않으면 업로드가 실패합니다.',
  zengjin: "선물",
  lc: "재무 관리",
  mb: "코인 구매",
  lsjl: "역사",
  zclb: "자산 목록",
  shaixuan: "필터",
  tagtip1: '태그는 특정 계정이나 사용자를 식별하기 위한 고유 코드로, 자금이 올바른 수취인에게 전송되도록 보장합니다.',
  tagtip2: '다른 거래 플랫폼이나 지갑에서는 태그를 디지털 ID, 태그, 메모, 노트, 설명 등으로 부를 수 있습니다.',
};



// WEBPACK FOOTER //
// ./src/i18n/lang/property/kr.js